import { Comments } from "../../../../../../../features/comments/components/comments/comments.component";
import { BasicResourceType } from "../../../../../../../types/resources/resources.enums";
import { FlyerDetailCommentsTabProps } from "./flyer-detail-comments-tab.props";

export const FlyerDetailCommentsTab = (props: FlyerDetailCommentsTabProps) => {
  return <Comments modelId={props.flyerId} modelName={BasicResourceType.Flyer} />;
};
